module.exports = __webpack_public_path__ + "static/media/coin.ef7c6b37.mp3";